import ProfileForm from 'app/form/ProfileForm';
import React from 'react';

const ProfileSection = () => {
	return (
		<div>
			<ProfileForm />
		</div>
	);
};

export default ProfileSection;
